// extracted by mini-css-extract-plugin
export default {"is-used-icon":"peripheral-used_is-used-icon__UIjSG"};